export default __webpack_public_path__ + "static/media/TFE.6bd43b10.png";